import React, { memo, useState } from 'react'
import Slider from 'react-slick'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useParams } from 'react-router'
import clsx from 'clsx'

/* components */
import Category from 'pages/sheared/Categories/Category'
import SectionSubTitle from 'components/ui/SectionSubTitle'

/* types */
import { propTypes } from 'modules/categories/store/types'

/* selectors */
import { getCategories } from 'modules/categories/store/selectors'

/* hooks */
import _useDidMount from 'hooks/lifecycle/use-did-mount'

/* utils */
import MQ from 'utils/mq'

/* constants */
import { MD_DOWN, SM_DOWN } from 'constants/screen-sizes'

/* actions */
import { getCategoriesListAction } from 'modules/categories/store/actions'

/* styles */
import classes from 'pages/sheared/Categories/index.module.scss'
import 'pages/sheared/Categories/slider.scss'

const Categories = ({ title, getCategoriesList, categories }) => {

  const [isLoaded, setIsLoaded] = useState(false)
  const params = useParams()

  _useDidMount(() => {
    getCategoriesList()
      .then(() => {
        setIsLoaded(true)
      })
  })

  if (!categories && isLoaded) {
    return (
      <div>
        Categories not found
      </div>
    )
  }

  if (!categories) {
    return null
  }

  const renderCategories = (categories) => categories.map((itemProps, index) => {
    if (params.slug !== itemProps.slug) {
      return (
        <Category
          key={index}
          {...itemProps}
        />
      )
    }
  })

  function split(array, elementsCountInEachArray) {
    const [...arr] = array
    const res = []
    while (arr.length) {
      res.push(arr.splice(0, elementsCountInEachArray))
    }
    return res
  }

  const categoriesForSlider = split(categories, 4)

  const renderCategoriesForSlider = () => categoriesForSlider.map((group, index) => (
    <div key={index}>
      {renderCategories(group)}
    </div>
  ))

  const sliderSettings = {
    className: 'categoriesSlider',
    dots: true,
    infinite: false,
    arrows: false,
    responsive: [
      {
        breakpoint: MD_DOWN,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: SM_DOWN,
        settings: {
          centerMode: true,
          centerPadding: '15px',
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <section className={clsx('categoriesSection', classes.categoriesSection)}>
      <div className={classes.categoriesSectionWrapper}>
        <div className="container">
          <div className={classes.categoriesSectionInner}>

            {title && (
              <SectionSubTitle
                item={title}
              />
            )}

            <MQ.SM_UP>
              <div className={classes.categoriesListWrapper}>
                {renderCategories(categories)}
              </div>
            </MQ.SM_UP>
            <MQ.SM_DOWN>
              <Slider {...sliderSettings}>
                {renderCategoriesForSlider()}
              </Slider>
            </MQ.SM_DOWN>

          </div>
        </div>
      </div>
    </section>
  )
}

Categories.propTypes = {
  getCategoriesList: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(propTypes)).isRequired,
}

const mapStateToProps = (state) => ({
  categories: getCategories(state),
})

const actionsToProps = {
  getCategoriesList: getCategoriesListAction,
}

export default connect(mapStateToProps, actionsToProps)(memo(Categories))
